// data/PolicySearchSchemas.js
import { DATE_FORMAT_REG_EXP } from "utils/datetime";

export const policySearchFormSchema = [
  {
    id: "code",
    group: "Policy Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Policy Code",
    value: "",
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "employerName",
    group: "Policy Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Employer Name",
    value: "",
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "status",
    group: "Policy Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Status",
    value: "",
    isRequired: false,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "", label: "All" },
      { value: "Active", label: "Active" },
      { value: "Pending Activation", label: "Pending Activation" },
      { value: "Expired", label: "Expired" },
      { value: "Suspended", label: "Suspended" },
    ],
  },
  {
    id: "policyTypeId",
    group: "Policy Information",
    label: "Policy Type",
    fieldType: "autocomplete",
    shownOnForm: true,
    width: "60%",
    isRequired: false,
    valueKey: "id",
    textValue: "label",
    onSearch: (query, deps) => {
      if (deps.onSearchPolicyTypes) {
        deps.onSearchPolicyTypes(query);
      }
    },
    options: (deps) => deps.policyTypes || [],
    loading: (deps) => deps.policyTypesLoading,
  },
  {
    id: "cardCode",
    group: "Card Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Card Code",
    value: "",
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "effectiveDateFrom",
    group: "Date Range",
    label: "Effective Date From",
    fieldType: "date",
    shownOnForm: true,
    width: "60%",
    isRequired: false,
    value: "",
    pattern: DATE_FORMAT_REG_EXP,
  },
  {
    id: "effectiveDateTo",
    group: "Date Range",
    label: "Effective Date To",
    fieldType: "date",
    shownOnForm: true,
    width: "60%",
    isRequired: false,
    value: "",
    pattern: DATE_FORMAT_REG_EXP,
  },
  {
    id: "expiryDateFrom",
    group: "Date Range",
    label: "Expiry Date From",
    fieldType: "date",
    shownOnForm: true,
    width: "60%",
    isRequired: false,
    value: "",
    pattern: DATE_FORMAT_REG_EXP,
  },
  {
    id: "expiryDateTo",
    group: "Date Range",
    label: "Expiry Date To",
    fieldType: "date",
    shownOnForm: true,
    width: "60%",
    isRequired: false,
    value: "",
    pattern: DATE_FORMAT_REG_EXP,
  },
];

export const policySearchRecord = {
  code: "",
  employerName: "",
  status: "",
  policyTypeId: null,
  cardCode: "",
  effectiveDateFrom: "",
  effectiveDateTo: "",
  expiryDateFrom: "",
  expiryDateTo: "",
  externalErrors: {},
};
